module.exports = __webpack_public_path__ + "static/img/bairuizhai_banner.7b9e50c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bairuizhai_banner.png
// module id = 1oDK
// module chunks = 62